import { Button, Input, Text } from "@rneui/themed";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { StyleSheet } from "react-native";
import Animated, { useAnimatedKeyboard, useAnimatedStyle, useDerivedValue, withTiming, } from "react-native-reanimated";
import { useBottomSheet } from "@gorhom/bottom-sheet";
import { PositionType } from "@annunciate/core";
import { useBookmarkDeleteMutation, useBookmarkUpsertMutation, } from "@annunciate/query";
import { getFormattedProgressAndRemainingTime } from "../../utils";
import { View } from "../elements";
export const NoteForm = ({ bookmark, onClose: onParentClose = () => { }, onSubmitSuccess = () => { }, }) => {
    const { snapToIndex, animatedPosition } = useBottomSheet();
    const { height: keyboardHeight } = useAnimatedKeyboard();
    const timedKeyboardHeight = useDerivedValue(() => withTiming(keyboardHeight.value));
    const keyboardAwareStyle = useAnimatedStyle(() => {
        return {
            flexGrow: 1,
            paddingBottom: animatedPosition.value + timedKeyboardHeight.value,
        };
    });
    const inputRef = useRef(undefined);
    const [body, setBody] = useState(bookmark.note || "");
    const [isCommenting, setIsCommenting] = useState(false);
    const { mutateAsync: update } = useBookmarkUpsertMutation();
    const onClose = useCallback(() => {
        setBody("");
        inputRef?.current?.clear();
        onParentClose();
        setIsCommenting(false);
    }, [onParentClose, setBody]);
    const updateBookmark = useCallback(async (body) => {
        try {
            await update({
                item: {
                    position: bookmark.position,
                    id: bookmark.id,
                    note: body,
                    contentId: bookmark.contentId,
                },
            });
            onSubmitSuccess();
        }
        catch (err) {
            console.log("Error editing bookmark", err);
        }
    }, [update, onSubmitSuccess]);
    const { mutate: deleteMutate } = useBookmarkDeleteMutation();
    const createdAt = new Date(bookmark.createdAt);
    const position = bookmark.position?.type === PositionType.TIME &&
        bookmark.position;
    const { timeProgressed } = position && bookmark.duration
        ? getFormattedProgressAndRemainingTime(position.value, bookmark.duration.length)
        : { timeProgressed: "" };
    useEffect(() => {
        snapToIndex(0);
    }, []);
    return (React.createElement(Animated.View, { style: keyboardAwareStyle },
        React.createElement(View, { style: styles.container },
            React.createElement(View, { style: styles.row },
                React.createElement(Text, null, createdAt.toLocaleString()),
                React.createElement(Text, null, timeProgressed)),
            React.createElement(Input, { ref: inputRef, value: body, multiline: true, maxLength: 10000, placeholder: "Add a note...", onChangeText: (t) => setBody(t), onFocus: () => setIsCommenting(true), onBlur: () => {
                    if (bookmark.note === body) {
                        setIsCommenting(false);
                    }
                }, on: true, containerStyle: { flexGrow: 1 }, inputStyle: styles.input, inputContainerStyle: styles.imputContainer, scrollEnabled: true }),
            isCommenting ? (React.createElement(View, { style: styles.submitCloseContainer },
                React.createElement(Button, { type: "clear", onPress: () => onClose() }, "Cancel"),
                React.createElement(Button, { style: { marginRight: 10 }, onPress: async () => {
                        await updateBookmark(body || "");
                        onClose();
                    }, disabled: body === bookmark.note ||
                        (body === "" && bookmark.note === null) }, "Submit"))) : (React.createElement(View, { style: styles.submitCloseContainer },
                React.createElement(Button, { onPress: () => onClose() }, "Back"),
                React.createElement(Button, { type: "solid", buttonStyle: { backgroundColor: "red" }, onPress: () => {
                        deleteMutate({
                            item: { id: bookmark.id },
                        });
                        onClose();
                    } }, "Delete"))))));
};
const styles = StyleSheet.create({
    container: {
        width: "100%",
        flexGrow: 1,
        padding: 16,
        gap: 12,
        justifyContent: "space-between",
    },
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        gap: 10,
        flexGrow: 0,
    },
    content: {
        gap: 12,
        flexGrow: 1,
        justifyContent: "space-between",
    },
    imputContainer: {
        flexGrow: 1,
        padding: 10,
        borderRadius: 10,
        borderColor: "grey",
        borderWidth: 1,
    },
    input: {
        flexGrow: 1,
        height: "100%",
        textAlignVertical: "top",
    },
    submitCloseContainer: {
        flexDirection: "row",
        justifyContent: "flex-end",
        width: "100%",
        flexGrow: 0,
        gap: 16,
    },
});
//# sourceMappingURL=NoteForm.js.map